import { useTranslation, withTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { fetchHeaderFooter } from 'uicomponents';
import { initializeMeControl } from './utils/meControlLoad';
import './App.css';
import Appeal from './components/Appeal';
import ErrorPage from './components/error/ErrorPage';
import i18next from 'i18next';

function App() {
  const urlPath = window.location.href;
  const params = window.location.search;
  const locale = i18next.resolvedLanguage ? i18next.resolvedLanguage : null;

  // Fetch the Universal Header and Footer (UHF) from Alpine and attach them to the document HTML.
  fetchHeaderFooter(locale ? locale : 'en-us');

  // Initialize the meControl once the UHF is loaded.
  initializeMeControl();

  const formId = new URLSearchParams(params).get("formId");
  const { t } = useTranslation();

  if (urlPath.includes("appeal")) {
    return (
      <main className="App">
        <title>{t('PublicForms.appeal')}</title>
        <Routes>
          <Route path=':lang/digitalsafety/appeal' element={<Appeal formId={formId} locale={locale} />} />
          <Route path='digitalsafety/appeal' element={<Appeal formId={formId} locale={locale} />} />
        </Routes>
      </main>
    );
  }

  else {
    return (
      <main className="App">
        <title>{t('Common.page-not-found')}</title>
        <ErrorPage errorHeader={t('Common.page-not-found')} />
      </main>
    );
  }
}

export default withTranslation()(App);
